import $ from 'jquery'
import Page from "./Page"

export default function init() {
    new Page().init($('.workflowSettingsPage'))
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/index.js